import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  isPutting: false,
  items: [],
  putError: null,
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_USECASES_REQUEST],
  falseTypes: [actions.GET_USECASES_SUCCESS, actions.GET_USECASES_FAILURE],
})

const isPutting = booleanReducer({
  defaultState: initialState.isPutting,
  trueTypes: [actions.PUT_ORG_USE_CASES_REQUEST],
  falseTypes: [
    actions.PUT_ORG_USE_CASES_SUCCESS,
    actions.PUT_ORG_USE_CASES_FAILURE,
  ],
})

const items = (state = initialState.items, { type, payload }) => {
  if (type === actions.GET_USECASES_SUCCESS) {
    return [...payload]
  }
  return state
}

const putError = (state = initialState.putError, { type, payload }) => {
  if (type === actions.PUT_ORG_USE_CASES_FAILURE) {
    return payload
  }
  if (
    type === actions.PUT_ORG_USE_CASES_REQUEST ||
    type === actions.PUT_ORG_USE_CASES_SUCCESS
  ) {
    return null
  }

  return state
}

export default combineReducers({
  isFetching,
  items,
  isPutting,
  putError,
})



// WEBPACK FOOTER //
// ./src/reducers/useCases.js